import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Form from '../../../common/Form';
import { closeModalAction } from '../../../actions/modal';
import Input from '../../../common/Form/Input';
import RenderMilestones from '../components/RenderMileStones';
import { useState } from 'react';
import { bulkSignoffUnlockAction, unlockSignoffServiceRequest } from '../../../actions/service_request';

const formName = 'unlock_signoff';

export const UnlockSignoff = ({ ticketId, milestones, isBulk = false, agents }) => {
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const defaultValues = { remark: '' };
    const dispatch = useDispatch();
    const methods = useForm({ defaultValues, mode: 'all' });
    const [selectedMilestones, setSelectedMilestones] = useState();

    const submit = (formValues) => {
        if (isBulk) {
            dispatch(bulkSignoffUnlockAction({ formName, milestone_ids: milestones.map(milestone => milestone.id), remark: formValues.remark }));
        } else {
            dispatch(unlockSignoffServiceRequest({ formName, ticketId, milestoneId: selectedMilestones, remark: formValues.remark }));
        }
    }

    return <Form
        methods={methods}
        onSubmit={submit}
        formName={formName}
        buttonPostion={'justify-end'}
        submitButtonText={'Submit'}
        onCancel={() => dispatch(closeModalAction())}
        showSubmit
        submitContainerClassName='flex gap-2 justify-end py-4 px-4'
        isLoading={formButtonLoading[formName]}
    >
        <div className='px-2 py-3'>
            {!isBulk ? <RenderMilestones milestones={milestones} selectedMilestones={selectedMilestones} setSelectedMilestones={setSelectedMilestones} agents={agents} /> : null}
            <Input name='remark' className='w-full' label='Remark' required />
        </div>
    </Form>
}